<template>
  <v-list-item v-if="canAccessSC" :active-class="color" :class="[{ mini: mini }, 'cm-hightlight-option']" @click="openPortal">
    <v-list-item-action class="overwrite-margin">
      <v-icon>mdi-road-variant</v-icon>
    </v-list-item-action>
    <v-list-item-title>Safety Centre</v-list-item-title>
  </v-list-item>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState([
      "goToken",
      "serviceList"
    ]),
    canAccessSC() {
      return this.serviceList.includes('safetyCentre')
    }
  },
  methods: {
    openPortal () {
      // link to the goportal
      location.replace(location.protocol + "//" + process.env.VUE_APP_go_dashboard)
    }
  }
}
</script>

<style lang="scss">
.overwrite-margin {
  margin-right: 20px !important;
}
</style>